import axios from 'axios';

// Configuração base da API
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3002/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('nexus-admin-auth');
    if (token) {
      try {
        const authData = JSON.parse(token);
        if (authData.state?.token) {
          config.headers.Authorization = `Bearer ${authData.state.token}`;
        }
      } catch (error) {
        console.error('Erro ao parsear token:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Se receber 401 (não autorizado), redirecionar para login
    if (error.response?.status === 401) {
      localStorage.removeItem('nexus-admin-auth');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

// Tipos para as respostas da API
export interface ApiResponse<T = any> {
  data: T;
  message?: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// Funções auxiliares para tratamento de erros
export const handleApiError = (error: any): string => {
  if (error.response?.data?.error) {
    return error.response.data.error;
  }

  if (error.message) {
    return error.message;
  }

  return 'Erro interno do servidor';
};

// Funções para formatar dados
export const formatDate = (dateString: string): string => {
  if (!dateString) return '-';

  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    return dateString;
  }
};

export const formatStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    Pendente: 'Pendente',
    'Em Andamento': 'Em Andamento',
    Concluída: 'Concluída',
    'Em Rota': 'Em Rota'
  };

  return statusMap[status] || status;
};

export const getStatusColor = (status: string): string => {
  const colorMap: Record<string, string> = {
    Pendente: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    'Em Andamento': 'bg-blue-100 text-blue-800 border-blue-200',
    Concluída: 'bg-green-100 text-green-800 border-green-200',
    'Em Rota': 'bg-purple-100 text-purple-800 border-purple-200'
  };

  return colorMap[status] || 'bg-gray-100 text-gray-800 border-gray-200';
};

export const getStatusIcon = (status: string): string => {
  const iconMap: Record<string, string> = {
    Pendente: '⏳',
    'Em Andamento': '🚗',
    Concluída: '✅',
    'Em Rota': '📍'
  };

  return iconMap[status] || '❓';
};
